// filepath: /src/components/Icon/Icon.tsx
import React from 'react';

// Import all your SVGs
import AttachIcon from '../../../../assets/icons/attach.svg?react';
import SendIcon from '../../../../assets/icons/send.svg?react';
import HeadIcon from '../../../../assets/icons/head-circuit.svg?react';
import BulbIcon from '../../../../assets/icons/lightbulb.svg?react';
import AtIcon from '../../../../assets/icons/at.svg?react';
import MinusIcon from '../../../../assets/icons/minus.svg?react';
import TrashIcon from '../../../../assets/icons/trash.svg?react';
// ... more imports

// Map icon names to components
const iconMap = {
    attach: AttachIcon,
    send: SendIcon,
    head: HeadIcon,
    bulb: BulbIcon,
    at: AtIcon,
    minus: MinusIcon,
    trash: TrashIcon,
  // ... more mappings
};

export type IconName = keyof typeof iconMap;

interface IconProps {
    name: IconName;
    size?: number;
    color?: string;
    className?: string;
    style?: React.CSSProperties;
}

export const Icon: React.FC<IconProps> = ({
    name,
    size = 24,
    className,
    style
}) => {
    const IconComponent = iconMap[name];

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found`);
        return null;
    }

    return (
    <IconComponent
        width={size}
        height={size}
        className={className}
        style={{
            ...style,
        }}
    />
    );
};
